import { render, staticRenderFns } from "./ceshijz.vue?vue&type=template&id=4175196d&scoped=true"
import script from "./ceshijz.vue?vue&type=script&lang=js"
export * from "./ceshijz.vue?vue&type=script&lang=js"
import style0 from "./ceshijz.vue?vue&type=style&index=0&id=4175196d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4175196d",
  null
  
)

export default component.exports